/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn Diagram Maker`)
};

const es_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Diagramas de Venn`)
};

const de_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn-Diagramm-Generator`)
};

const nl_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn-diagram Maker`)
};

const fr_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme de Venn`)
};

const it_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di Diagrammi di Venn`)
};

const pt_br2_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Diagrama de Venn`)
};

const pt_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Diagramas de Venn`)
};

const ja_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベン図作成ツール`)
};

const zh_venn_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维恩图生成器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_tool_name", locale)
	if (locale === "en") return en_venn_tool_name(inputs)
	if (locale === "es") return es_venn_tool_name(inputs)
	if (locale === "de") return de_venn_tool_name(inputs)
	if (locale === "nl") return nl_venn_tool_name(inputs)
	if (locale === "fr") return fr_venn_tool_name(inputs)
	if (locale === "it") return it_venn_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_venn_tool_name(inputs)
	if (locale === "pt") return pt_venn_tool_name(inputs)
	if (locale === "ja") return ja_venn_tool_name(inputs)
	return zh_venn_tool_name(inputs)
};